<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_11",
      next: "P_13",
      topic: "",
      progress: false
    };
  }
};
</script>
<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | TALLER ¿QUÉ ES CRÉDITO?
            v-card-text.titulo36Book
              | ¡Quiero saber qué es y para qué sirve un crédito! 
            p
              v-img(style='width:100%;', :src='require("@/assets/TCC-L4-Pagina1 A.png")')
            v-card-text.parrafoDestacado18
              | Existen diferentes tipos de financiamiento que ayudan a enfrentar una necesidad y alcanzar metas. Debes asegurarte de conocer las características de los distintos tipos para que elijas el que más te conviene y sacarle el mejor provecho. 
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage(next)")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


